import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ToasterService } from '../../../services/ToasterService';
import { AuthService } from '../../../services/AuthService';
import { STATUS_SUCCESS } from '../../../utils/constants';
import { useLoader } from '../../../context/LoaderContext';

type FormData = {
  mobile: string;
};

type Errors = Partial<Record<keyof FormData, string>>;

const UseUserLoginPage = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState<FormData>({
    mobile: '',
  });
  const { setLoading } = useLoader();
  const [errors, setErrors] = useState<Errors>({});
  const [buttonLoading, setButtonLoading] = useState(false);

  // Handle input change
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    const numericValue = value.replace(/\D/g, '');
    setFormData(prev => ({ ...prev, [name]: numericValue }));
    setErrors(prev => ({ ...prev, [name]: '' }));
  };

  // Validate form input
  const validate = (): boolean => {
    const newErrors: Errors = {};
    const mobile = formData.mobile.trim();

    if (!mobile) {
      newErrors.mobile = 'Mobile number is required';
    } else if (!/^\d+$/.test(mobile)) {
      newErrors.mobile = 'Mobile number must contain only digits';
    } else if (mobile.length !== 10) {
      newErrors.mobile = 'Mobile number must be exactly 10 digits';
    } else if (!/^[6-9]\d{9}$/.test(mobile)) {
      newErrors.mobile = 'Enter a valid 10-digit Indian mobile number';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  // Handle form submit
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!validate()) return;

    setButtonLoading(true);
    setLoading(true);

    try {
      localStorage.clear();
      const resp = await AuthService.UserLogin(formData.mobile);
      const apiResp = resp.message;

      if (apiResp.status == STATUS_SUCCESS) {
        setLoading(false);
        const newExpire = Date.now() + 60 * 1000;
        localStorage.setItem('otpExpireAt', newExpire.toString());
        setButtonLoading(false);
        console.log('resp.message', resp.message);
        ToasterService.Success('OTP sent successfully!');
        navigate('/otp-verify', { state: { mobile: formData.mobile } });
      } else if (apiResp.status === 'failed') {
        setButtonLoading(false);
        setLoading(false);
        ToasterService.Error(apiResp.message ? apiResp.message : 'No Customer Found!..');
      } else {
        setButtonLoading(false);
        setLoading(false);
        ToasterService.Error('Server error. Please try again sometime!');
      }
    } catch {
      setLoading(false);
      ToasterService.Error('Server error. Please try again sometime!');
      setButtonLoading(false);
    }
  };

  return {
    formData,
    errors,
    buttonLoading,
    handleChange,
    handleSubmit,
  };
};

export default UseUserLoginPage;
